<template>
  <div class="link-views no-bg">
    <Row :gutter="16" type="flex" class="virtualLab">
      <i-col :xs="24" :sm="24" :md="8">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item2.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">虚拟仿真实验总数</div>
            <div class="big theme">{{ExpCount}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="8">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item2.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">操作实验有效数（教师）</div>
            <div class="big theme">{{TchCount}}</div>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="8">
        <div class="bg-div">
          <div class="img">
            <img src="../../../assets/imgs/item2.png">
          </div>
          <div class="imgInfo">
            <div class="small text-overflow">操作实验有效数（学生）</div>
            <div class="big theme">{{StuCount}}</div>
          </div>
        </div>
      </i-col>
    </Row>

    <!--  -->
    <Row :gutter="16" type="flex">
      <i-col :xs="24" :sm="24" :md="24" :lg="7" :xxl="7">
        <div class="result" id="result" ref="result">
          <div class="resultTitle">本周教学任务</div>
          <div style="padding:0 20px;margin-bottom:16px;" v-if="CourseList.length>0">
            <div v-for="(item,index) in CourseList" :key="index" class="top">
              <div>授课老师：{{item.UserName}}</div>
              <div>授课课程：{{item.CourseName}}</div>
            </div>
          </div>
          <div style="padding:0 20px;margin-bottom:16px;" v-else>本周暂无教学任务</div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="10" :xxl="10">
        <div class="result" id="result" ref="result">
          <div class="resultTitle">成绩统计</div>
          <div style="padding:0 20px;margin-bottom:16px;">
            <span>实验名称：</span>
            <i-select v-model="ExpID1" style="width:200px">
              <i-option
                v-for="item in ExperimentList"
                :value="item.ExpID"
                :key="item.ExpID"
              >{{ item.ExpName }}</i-option>
            </i-select>
          </div>
          <div class="resultInfo">
            <ve-histogram
              :grid="{left:16,right:60}"
              :judge-width="true"
              :data="chartData6"
              :settings="chartSettings6"
              :data-empty="dataEmpty6"
              :extend="chartExtend6"
              :height="height1"
            ></ve-histogram>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="7" :xxl="7">
        <div class="result">
          <div class="resultTitle">成绩分段统计</div>
          <div style="padding:0 20px;margin-bottom:16px;">
            <span>实验名称：</span>
            <i-select v-model="ExpID2" style="width:200px">
              <i-option
                v-for="item in ExperimentList"
                :value="item.ExpID"
                :key="item.ExpID"
              >{{ item.ExpName }}</i-option>
            </i-select>
          </div>
          <div style="padding:0 20px;margin-bottom:16px;">
            <span>班级名称：</span>
            <i-select v-model="ClassId" style="width:200px">
              <i-option
                v-for="item in CollegeClassList"
                :value="item.ClassId"
                :key="item.ClassId"
              >{{ item.ClassName }}</i-option>
            </i-select>
          </div>
          <div class="resultInfo">
            <ve-histogram
              :grid="{left:16,right:16}"
              :judge-width="true"
              :data="chartData7"
              :extend="chartExtend7"
              :settings="chartSettings7"
              :data-empty="dataEmpty7"
               :height="height2"
            ></ve-histogram>
          </div>
        </div>
      </i-col>
    </Row>
    <!-- 按照时间 -->
    <div class="select-div">
      <div class="mr">
        <span>开始时间-结束时间：</span>
        <DatePicker
          v-model="daterange"
          format="yyyy-MM-dd"
          type="daterange"
          placement="bottom-start"
          placeholder="Select date"
          style="width: auto"
          clearable
          :editable="false"
          @on-change="getTime"
        ></DatePicker>
      </div>
      <div>
        <Button type="primary" class="mr" icon="md-search" @click="searchByTime('search')">查询</Button>
        <Button type="primary" icon="md-refresh" @click="searchByTime('refresh')">重置</Button>
      </div>
    </div>
    <!--  -->
    <Row :gutter="16" type="flex">
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result" id="result" ref="result">
          <div class="resultTitle">学生操作实验排行（前十）</div>
          <div class="resultInfo">
            <ve-histogram
              :grid="{left:16,right:16}"
              :judge-width="true"
              :data="chartData1"
              :extend="chartExtend1"
              :settings="chartSettings1"
              :data-empty="dataEmpty1"
            ></ve-histogram>
          </div>
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result">
          <div class="resultTitle">教师操作实验排行（前十）</div>
          <div class="resultInfo">
            <ve-histogram
              :grid="{left:16,right:16}"
              :judge-width="true"
              :data="chartData2"
              :extend="chartExtend1"
              :settings="chartSettings1"
              :data-empty="dataEmpty2"
            ></ve-histogram>
          </div>
        </div>
      </i-col>
    </Row>
    <!--  -->
    <Row :gutter="16" type="flex">
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result" id="result" ref="result">
          <div class="resultTitle">虚拟实验操作前五占比（%）</div>
           <Row :gutter="16" type="flex" style="padding:0 16px;">
            <i-col :xs="24" :sm="24" :md="24" :lg="24" :xxl="12">
              <ve-ring
                :grid="{left:16,right:16}"
                :judge-width="true"
                :data="chartData3"
                :extend="chartExtend3"
                :settings="chartSettings3"
                :data-empty="dataEmpty3"
              ></ve-ring>
            </i-col>
            <i-col :xs="24" :sm="24" :md="24" :lg="24" :xxl="12">
              <ve-ring
                :grid="{left:16,right:16}"
                :judge-width="true"
                :data="chartData4"
                :extend="chartExtend4"
                :settings="chartSettings4"
                :data-empty="dataEmpty4"
              ></ve-ring>
            </i-col>
          </Row>
         
        </div>
      </i-col>
      <i-col :xs="24" :sm="24" :md="24" :lg="12" :xxl="12">
        <div class="result">
          <div class="resultTitle">实验操作总次数</div>
          <div class="resultInfo">
            <ve-line
              :grid="{left:16,right:30}"
              :judge-width="true"
              :data="chartData5"
              :extend="chartExtend5"
              :settings="chartSettings5"
              :data-empty="dataEmpty5"
            ></ve-line>
          </div>
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import * as homeConst from "../../../apiconfig/index.js";
import * as homeApi from "../../../api/teacher-api.js";
import VeHistogram from "v-charts/lib/histogram.common.js";
import VeRing from "v-charts/lib/ring.common.js";
import VeBar from "v-charts/lib/bar.common.js";
export default {
  name: "collegeStatistics",
  components: {
    VeHistogram,
    VeRing,
    VeBar
  },
  data() {
    this.chartExtend1 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "<br/>" +
            params[0].seriesName +
            "：" +
            params[0].data +
            "次" +
            "<br/>" +
            params[1].seriesName +
            "：" +
            params[1].data +
            "min"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings1 = {
      axisSite: { right: ["TimeLength"] },
      yAxisName: ["次数", "时长（min）"],
      showLine: ["TimeLength"],
      labelMap: {
        Count: "次数",
        TimeLength: "时长"
      }
    };

    this.chartExtend3 = {
      title: {
        text: "次数(次)"
      },
      legend: {
        orient: "vertical",
        y: "bottom"
      },
      tooltip: {
        trigger: "item",
        formatter: "{b}: <br/>{c}(次) ({d}%)",
        confine: true
      }
    };
    this.chartSettings3 = {
      name: "次数",
      radius: [60, 80],
      offsetY: 160,
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
          position: "center"
        },
        emphasis: {
          show: true,
          textStyle: {
            fontSize: "14"
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }
    };
    this.chartExtend4 = {
      title: {
        text: "时长（min）"
      },
      legend: {
        orient: "vertical",
        y: "bottom"
      },
      tooltip: {
        trigger: "item",
        formatter: "{b}: <br/>{c}(min) ({d}%)",
        confine: true
      }
    };
    this.chartSettings4 = {
      name: "时长",
      radius: [60, 80],
      offsetY: 160,
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
          position: "center"
        },
        emphasis: {
          show: true,
          textStyle: {
            fontSize: "14"
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }
    };
    this.chartExtend5 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return params[0].axisValue + "：<br/>" + params[0].data[1] + "次";
        },
        confine: true
      }, xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings5 = {
      area: true,
      labelMap: {
        Count: ""
      }
    };
    this.chartExtend6 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return (
            params[0].axisValue +
            "<br/>" +
            params[0].seriesName +
            "：" +
            params[0].data +
            "分" +
            "<br/>" +
            params[1].seriesName +
            "：" +
            params[1].data +
            "分"
          );
        },
        confine: true
      },
      xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings6 = {
      yAxisName: ["分数"],
      labelMap: {
        ScoreP: "平时成绩",
        ScoreK: "考核成绩"
      }
    };
    this.chartExtend7 = {
      tooltip: {
        show: true,
        formatter: function(params) {
          return params[0].axisValue + "：<br/>" + params[0].data + "人";
        },
        confine: true
      }, xAxis: {
        axisLabel: {
          interval: 0, //0：全部显示，1：间隔为1显示对应类目，2：依次类推，（简单试一下就明白了，这样说是不是有点抽象）
          rotate: -15 //倾斜显示，-：顺时针旋转，+或不写：逆时针旋转
        }
      }
    };
    this.chartSettings7 = {
      labelMap: {
        Count: ""
      }
    };
    return {
      height1: "400px",
      height2:"400px",
      ExpCount: 0,
      StuCount: 0,
      TchCount: 0,
      daterange: "",
      pageData: {
        StartTime: "",
        EndTime: ""
      },
      CourseList: [],
      chartData1: {},
      dataEmpty1: true,
      chartData2: {},
      dataEmpty2: true,
      chartData3: {},
      dataEmpty3: true,
      chartData4: {},
      dataEmpty4: true,
      chartData5: {},
      dataEmpty5: true,
      chartData6: {},
      dataEmpty6: true,
      chartData7: {},
      dataEmpty7: true,
      ExperimentList: [],
      CollegeClassList: [],
      ClassId: 0,
      ExpID1: 0,
      ExpID2: 0
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  watch: {
    ExpID1(val) {
      this.GetFieldCollegeScore(val);
    },
    ExpID2(val) {
      if (val) {
        this.GetFieldCollegeScoreD(val, this.ClassId);
      }
    },
    ClassId(val) {
      if (val) {
        this.GetFieldCollegeScoreD(this.ExpID2, val);
      }
    }
  },
  mounted() {
    this.getCollegeClassList(); //获取所有班级
    this.getExperimentList(); //获取实验列表
    this.getDaterange(); //获取时间段
    this.getInfoData(); //获取基本信息
    this.getInfoDataSj(this.pageData); //学院统计时间端段信息
  },
  methods: {
    //获取当前时间
    getDaterange() {
      var day = new Date();
      day.setDate(day.getDate() - 7);
      var s1 = day.format("yyyy-MM-dd");
      this.pageData.StartTime = s1;
      this.pageData.EndTime = new Date().format("yyyy-MM-dd");
      this.daterange = [this.pageData.StartTime, this.pageData.EndTime];
    },
    //学院统计基本信息
    getInfoData() {
      homeApi.GetFieldCollegeTj().then(res => {
        this.ExpCount = res.ExpCount;
        this.StuCount = res.StuCount;
        this.TchCount = res.TchCount;
        this.CourseList = res.CourseList;
        this.height1 =
          res.CourseList.length * 60 > 400
            ? res.CourseList.length * 60 + "px"
            : "400px";
             this.height2 =
          res.CourseList.length * 60-40 > 400
            ? res.CourseList.length * 60-40 + "px"
            : "400px";
      });
    },
    //学院统计时间端段
    getInfoDataSj(pageData) {
      homeApi.GetFieldCollegeSj(pageData).then(res => {
        // 学生
        if (res.SCount.length > 0) {
          this.chartData1 = {
            columns: ["StuName", "Count", "TimeLength"],
            rows: res.SCount
          };
          this.dataEmpty1 = false;
        } else {
          this.chartData1 = {};
          this.dataEmpty1 = true;
        }
        // 教师
        if (res.TCount.length > 0) {
          this.chartData2 = {
            columns: ["TchName", "Count", "TimeLength"],
            rows: res.TCount
          };
          this.dataEmpty2 = false;
        } else {
          this.chartData2 = {};
          this.dataEmpty2 = true;
        }
        // 次数
        if (res.ExpTopC.length > 0) {
          this.chartData3 = {
            columns: ["ExpName", "Count"],
            rows: res.ExpTopC
          };
          this.dataEmpty3 = false;
        } else {
          this.chartData3 = {};
          this.dataEmpty3 = true;
        }
        // 时长
        if (res.ExpTopT.length > 0) {
          this.chartData4 = {
            columns: ["ExpName", "TimeLength"],
            rows: res.ExpTopT
          };
          this.dataEmpty4 = false;
        } else {
          this.chartData4 = {};
          this.dataEmpty4 = true;
        }
        if (res.ExpCounts.length > 0) {
          this.chartData5 = {
            columns: ["ExpName", "Count"],
            rows: res.ExpCounts
          };
          this.dataEmpty5 = false;
        } else {
          this.chartData5 = {};
          this.dataEmpty5 = true;
        }
      });
    },
    // 时间处理
    getTime(value) {
      if (value.length > 0) {
        this.pageData["StartTime"] = value[0];
        this.pageData["EndTime"] = value[1];
      }
    },
    // 按照时间查看
    searchByTime(type) {
      if (type == "refresh") {
        this.getDaterange();
      } else {
        this.pageData["StartTime"] = this.pageData["StartTime"];
        this.pageData["EndTime"] = this.pageData["EndTime"];
      }
      this.getInfoDataSj(this.pageData);
    },
    // 获取所有实验
    getExperimentList() {
      homeApi
        .GetExperimentList({
          Search: ""
        })
        .then(res => {
          this.ExperimentList = res;
          if (res.length > 0) {
            this.ExpID1 = res[0].ExpID;
            this.ExpID2 = res[0].ExpID;
          }
        });
    },
    // 获取所有班级
    getCollegeClassList() {
      homeApi.GetCollegeClass().then(res => {
        this.CollegeClassList = res;
        if (res.length > 0) {
          this.ClassId = res[0].ClassId;
        }
      });
    },
    // 成绩统计
    GetFieldCollegeScore(ExpID) {
      homeApi.GetFieldCollegeScore({ ExpID: ExpID }).then(res => {
        // 学生
        if (res.length > 0) {
          this.chartData6 = {
            columns: ["ClassName", "ScoreP", "ScoreK"],
            rows: res
          };
          this.dataEmpty6 = false;
        } else {
          this.chartData6 = {};
          this.dataEmpty6 = true;
        }
      });
    },
    // 成绩分段统计
    GetFieldCollegeScoreD(ExpID, ClassId) {
      homeApi
        .GetFieldCollegeScoreD({ ExpID: ExpID, ClassId: ClassId })
        .then(res => {
          // 学生
          if (res.length > 0) {
            this.chartData7 = {
              columns: ["Score", "Count"],
              rows: res
            };
            this.dataEmpty7 = false;
          } else {
            this.chartData7 = {};
            this.dataEmpty7 = true;
          }
        });
    }
  }
};
</script>

<style scoped>
.resultInfo{
display: inline-block;
}
</style>